import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import styles from "./TestbuyCardFragment.module.css";
import { Trans, useTranslation } from "@coworker/locales";
import { getStrategyTranslationKey } from "@coworker/apprestructured/src/testbuy/helpers/getStrategyTranslationKey";

export type TestbuyCardFragmentConfigProps = {
  strategyField: string;
  articleCountField: string;
  customArticlesField: string;
};

type TestbuyCardFragmentProps = {
  configProps: TestbuyCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function TestbuyCardFragment({
  configProps,
  commonProps,
}: TestbuyCardFragmentProps) {
  const { strategyField, articleCountField, customArticlesField } = configProps;
  const { task } = commonProps;
  const { t } = useTranslation();

  if (!strategyField || !articleCountField || !customArticlesField) {
    return null;
  }

  const strategy = getTypedValue<string>(getByPath(task, strategyField));
  const strategyText = isLoading(strategy)
    ? ""
    : getStrategyTranslationKey(strategy);

  const articlesCount = getTypedValue<number>(
    getByPath(task, articleCountField)
  );
  const articlesCountText = isLoading(articlesCount) ? "" : articlesCount || 0;

  const customArticles = getTypedValue<string[]>(
    getByPath(task, customArticlesField)
  );
  const customArticlesCountText = isLoading(customArticles)
    ? ""
    : customArticles.length || 0;

  return (
    <FixaText textStyle="Body.M" className={styles["root"]}>
      <Trans>{strategyText}</Trans>
      {` • ${articlesCountText || customArticlesCountText} ${t("articlesLowerCaseString")}`}
    </FixaText>
  );
}

export default TestbuyCardFragment;
